import { ApiResponse } from "helpers/fetch-wrapper";
import React from "react";
import { OrderQueries } from "queries/order-queries";

export type Order = {
    id: string;
    recipient_name: string;
    recipient_phone: string;
    delivery_address: string;
    product_cost: number;
    is_done: boolean;
    created_at: string;
    items: OrderItems[];
    action: React.ReactNode;
}

interface OrderItems {
    product_id: string;
    price: string;
    quantity: number;
    product_details: {
        name: string;
        category: string;
        image_url: string;
    }
}

export async function getOrderData() {
    try {
        const response = await OrderQueries.getOrders();
        const data: Order[] = await response.json();

        const apiResponse: ApiResponse<Order[]> = {
            body: data,
            // body: null,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        // console.log(apiResponse)

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: [],
            message: 'Failed to get products, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}

export async function markOrderAsDone(orderId: string) {
    try {
        const response = await OrderQueries.markAsDelivered(orderId);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: null,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        // console.log(apiResponse)

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to mark order as done, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}